import { ZdsCarousel, ZdsVideo } from '@zig-design-system/ui-components-react';
import React from 'react';
const Images = ({ images }) => {
    return (React.createElement("div", { className: `${images.length === 1 ? 'default-content' : 'wide-content'} zds-margin-bottom-6` },
        React.createElement(ZdsCarousel, { className: 'carousel-fixed-height', breakout: "full-width", slideGap: true, pagination: false, fullscreenAble: true, showNavigation: "bottom-left", visibleSlides: 'auto' }, images.map((image, index) => {
            if (!image.url) {
                return null;
            }
            if (image.extension === 'youtube') {
                const pattern = /(?:youtube(?:-nocookie)?\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=|shorts\/)|youtu\.be\/)([^"&?\/\s]{11})/i;
                const match = image.url.match(pattern);
                const videoId = match ? match[1] : null;
                if (!videoId) {
                    return null;
                }
                return (React.createElement(ZdsVideo, { key: index, videoTitle: image.name, url: `https://www.youtube-nocookie.com/embed/${videoId}?disablekb=1` }));
            }
            return React.createElement("img", { key: index, src: image.url, title: image.name, alt: image.name, loading: "lazy" });
        }))));
};
export default Images;
